import React from 'react'
import { useAuth } from '../../context/AuthContext';

function Notguest() {
  const { logout } = useAuth();

  return (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 10, height: '100vh'}}>
        <div style={{color: '#020617', fontSize: 20, fontWeight: 500}}>Вам сюда нельзя</div>
        <div onClick={logout} style={{color: 'grey', fontSize: 20, fontWeight: 500, cursor: 'pointer', textDecoration: 'underline'}}>Выйти и войти заново</div>
    </div>
  )
}

export default Notguest
